import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";

import PanelLayout from "layouts/PanelLayout";
import { TbSmartHome } from "react-icons/tb";
import { MdKeyboardArrowRight } from "react-icons/md";
import testImg from "assets/layout_img/test.svg";

import "styles/teacher.css";

const TEST_CARDS = [
  { id: 1, img: testImg, title: "Testlar", route: "/student/tests" },
  { id: 2, img: testImg, title: "Natijalar", route: "/student/results" },
  { id: 3, img: testImg, title: "Hujjatlar", route: "/student/docs" },
];

const StudentSubjectsIntro = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const subject = location.state;

  useEffect(() => {
    if (!subject) navigate("/student");
  }, [subject, navigate]);

  const goToPage = (route) => {
    navigate(route, { state: { subject } });
  };

  return (
    <PanelLayout>
      <div className="subject-page">
        <div className="breadcrumb">
          <span onClick={() => navigate("/student")}>
            <TbSmartHome style={{ fontSize: 20, color: "#01CC0D" }} />
          </span>
          <span className="divider">/</span>
          <span className="current">{subject?.title || "Fan"}</span>
        </div>

        <motion.div
          className="tests-flex"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          {TEST_CARDS.map((item, index) => (
            <motion.div
              key={item.id}
              className="test-card"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ scale: 1.03, y: -4 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => goToPage(item.route)}
            >
              <span className="card-content">
                <img src={item.img} alt={item.title} loading="lazy" />
                <p>{item.title}</p>
              </span>

              <motion.button
                className="start-btn"
                whileHover={{ scale: 1.15 }}
                whileTap={{ scale: 0.92 }}
              >
                <MdKeyboardArrowRight className="arrow-icon" />
              </motion.button>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </PanelLayout>
  );
};

export default StudentSubjectsIntro;
